<div class="header">
  <img
    src="./assets/images/nestle-logo.png"
    routerLink="/"
    class="header__logo"
  />
  <span class="header__name">{{ 'APP_NAME' | translate }}</span>

  <p-dropdown
    [options]="languages"
    class="p-d-flex p-jc-end header__languages"
    [(ngModel)]="selectedLanguage"
    (onChange)="changeLanguage($event.value.code)"
    optionLabel="name"
  ></p-dropdown>
  <p-dropdown
    [options]="languagesBrief"
    class="p-d-flex p-jc-end header__languages--brief"
    [(ngModel)]="selectedLanguage"
    (onChange)="changeLanguage($event.value.code)"
    optionLabel="name"
  ></p-dropdown>

  <span class="header__env"> {{ currentEnv | translate }}</span>
</div>
